import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-warning-modal',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.css']
})
export class WarningModalComponent implements OnInit {
  message: string;
  title: string;
  ok = () => {};
  constructor(public bsModalRef: BsModalRef) {} 

  ngOnInit() {
    
  }  
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/shared/components/warning-modal/warning-modal.component.ts